export function pressureAltitude(elevation, altimeter) {
  if (!Number.isFinite(elevation) || !Number.isFinite(altimeter)) return "";
  return elevation + (29.92 - altimeter) * 1000;
}

export function densityAltitude(pa, oatC) {
  if (!Number.isFinite(pa) || !Number.isFinite(oatC)) return "";

  const isaC = 15 - 2 * (pa / 1000);
  return pa + 120 * (oatC - isaC);
}